import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Loader from "../../../components/loader";

const RemoveScreenModal = ({
  isRemoveOpen,
  closeRemoveModal,
  deleteWelcomeScreenCms,
}) => {
  const handleDelete = async () => {
    deleteWelcomeScreenCms();
    closeRemoveModal();
  };

  return (
    <>
      <Modal show={isRemoveOpen} onHide={closeRemoveModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Remove Onboarding Screen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to remove this screen from Welcome Screens?
        </Modal.Body>
        <Modal.Footer>
          <Button text="Close" callBack={closeRemoveModal} />
          <Button text="Delete" callBack={handleDelete} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RemoveScreenModal;
